import { useEffect } from 'react';
import { useToast } from '../context/ToastContext';
import { useLanguage } from '../context/LanguageContext';
import { registerRateLimitHandler } from '../utils/apiInterceptor';

// LOT URGENT P0 FE-1 — pont entre l'intercepteur axios (module-level, hors
// React) et les contextes React (toast + i18n). Monte une fois, enregistre
// le handler appele quand un 429 persiste apres 3 retries. Ne rend rien.

export function ApiInterceptorBridge() {
  const { showError } = useToast();
  const { t } = useLanguage();

  useEffect(() => {
    registerRateLimitHandler(() => {
      // Toast Lot 1 — nouvelle signature (message, { title }).
      // Invariant 429 : title + message visibles identiques au comportement antérieur.
      showError(t('errors.rateLimit.message'), { title: t('errors.rateLimit.title') });
    });
  }, [showError, t]);

  return null;
}
